import React from 'react';
import FilterList from '../../../components/user/provider/providerFilterList';
import Layout from '../../../components/layouts/verticalLayout';

const ViveroListPage = (props) => {
  return <Layout body={<FilterList />} />;
};

ViveroListPage.propTypes = {};

export default ViveroListPage;
